import { useNavigate } from "react-router";
import { BASE } from "../lib/env";
import { useManifestStore } from "../state/manifestStore";

interface TopBarProps {
  tenant: string;
  title: string;
  crumbs?: { label: string; to?: string }[];
}

export function TopBar({ tenant, title, crumbs }: TopBarProps) {
  const navigate = useNavigate();
  const manifest = useManifestStore((s) => s.manifest);
  const tenants = manifest?.tenants ?? [];
  const active = tenants.find((t) => t.id === tenant);

  return (
    <div className="app-topbar">
      <div className="topbar-title">
        {active?.logo ? <img className="tenant-logo" src={`${BASE}${active.logo}`} alt="" /> : null}
        <div>
          {crumbs && crumbs.length > 0 ? (
            <div className="crumbs">
              {crumbs.map((c, i) => (
                <span key={c.label}>
                  {i > 0 ? " / " : ""}
                  {c.to ? <a href={c.to}>{c.label}</a> : c.label}
                </span>
              ))}
            </div>
          ) : null}
          <h1>{title}</h1>
        </div>
      </div>
      <div className="tenant-picker">
        {tenants.length > 1 ? (
          <select
            value={tenant}
            onChange={(e) => {
              const next = e.target.value;
              navigate(`/${next}`);
            }}
          >
            {tenants.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        ) : (
          <span className="meta-label mono">{tenant}</span>
        )}
      </div>
    </div>
  );
}
